export default __webpack_public_path__ + "static/media/close-hover.7a6651df.webp";